@import 'node_modules/@gaiads/telia-react-component-library/build/styles/colors';
@import 'node_modules/@gaiads/telia-react-component-library/build/styles/zindex';
@import '../../fonts';

.cart {
  display: block;
  position: relative;

  /* This needs to be block for the focus outline to display properly in Firefox. The Link component does not provide access to this inner element. */
  & > span {
    display: block;
    line-height: 0;
  }

  &:focus {
    outline-offset: 3px;
    outline: solid 4px color(blue500);
  }

  &_amount {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -8px;
    right: -8px;
    width: 20px;
    height: 20px;
    line-height: 0;
  }

  &_amountNumber {
    @include helvetica();
    font-weight: bold;
    padding-left: 1px;
    font-size: 11px;
    color: color(white);
    z-index: z('default');
  }

  &_amountIcon {
    position: absolute;
    width: 20px;
    height: 20px;
  }
}
